module.exports = __webpack_public_path__ + "img/zhgkw.81893d08.png";